import React from 'react'
import { Col, Row } from "reactstrap";

// components
import InfoRowComponent from "./tools/InfoRowComponent";
import WishlistButtons from "./tools/WishlistButtons";

const WishlistItemRow = props => {
    const { wishlist, component } = props

    return <div className={'wl-list-container ptb-1em'}>
        <Row>
            <Col sm={1} className={'fex-center'}>
                {wishlist?.reservationNumber}
            </Col>
            <Col sm={3} className={'wl-guest-info fex-center fex-colum'}>
                <label>{wishlist?.visitor?.name}</label>
                <label className={'link'}>{wishlist?.visitor?.email}</label>
            </Col>
            <Col sm={2} className={'wl-guest-info fex-center fex-colum'}>
                <label>{component?.type}</label>
                <label>{component?.title}</label>
            </Col>
            <Col sm={1} className={'fex-center'}>
                {component?.date}
            </Col>
            <Col sm={1} className={'fex-center'}>
                {component?.hour}
            </Col>
            <Col sm={1} className={'fex-center'}>
                {component?.pax}
            </Col>
            <Col sm={3} className={'fex-center'}>
                <WishlistButtons style={'pt-middle-em'} {...props} />
            </Col>
        </Row>
    </div>

    return <div className={'wl-list-container ptb-1em'}>
        <Row>
            <Col md={'10'}>
                <InfoRowComponent {...props}/>
            </Col>
            <Col md={'2'}>
                <div className={'fex-center'}>
                    <WishlistButtons {...props} />
                </div>
            </Col>
        </Row>
    </div>
}

export default WishlistItemRow